/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { useTranslation } from 'react-i18next';
import { TableCell } from '@material-ui/core';
import React from 'react';
import classNames from 'classnames';
import useStyles from '../FOTableHeadStyle';

const FOHeadActionCell = ({ data }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <TableCell align={data.align} className={classNames(classes.tableHeadCell, classes.tableHeadActionCell)}>
      {t(data.label)}
    </TableCell>
  );
};

FOHeadActionCell.defaultProps = {
  data: {
    align: 'center',
    label: 'Actions',
  },
};

function propsAreEqual(prevProps, nextProps) {
  return prevProps.label === nextProps.label && prevProps.hasTooltip === nextProps.hasTooltip;
}

const MemoizedFOHeadActionCell = React.memo(FOHeadActionCell, propsAreEqual);

export default MemoizedFOHeadActionCell;
